<template>
    <div class="au-shell">
        <AuthSidebar />
        <div class="au-main">
            <AuthNavbar />
            <main class="au-content">
                <router-view />
            </main>
            <AuthFooter />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthSidebar from "./auth/AuthSidebar.vue";
import AuthNavbar from "./auth/AuthNavbar.vue"
import AuthFooter from "./auth/AuthFooter.vue";

export default defineComponent({
    components: {
        AuthSidebar,
        AuthNavbar,
        AuthFooter
    },
});
</script>
